<template>
    <div id="container">
        <div id="top">
            <img src="./assets/LUMI_dark_1000px.png" alt=""/>
        </div>
        <div id="square">
            <div id="login-h3"><h3>Welcome to LUMI-O credentials management service</h3></div>
            <p id="login-p1">This service is for managing S3 object storage credentials for LUMI projects</p>
            <form :action="path" method="GET">
                <button type="submit" id="login-button">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="#ffffff">
                        <path d="m12 20-1.425-1.4 5.6-5.6H4v-2h12.175l-5.6-5.6L12 4l8 8Z"/>
                    </svg>
                    Go to login
                </button>
            </form> 
            <p id="login-p2">You will be redirected to authenticate with your identity provider</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "LoginPage",
    computed: {
        path() {
            return process.env.VUE_APP_LOGIN_PATH;
        }
    }
}
</script>

<style scoped>

#container {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
}

#top {
    margin-bottom: 2rem;
    width: 10rem;
}

#top img {
    width: 100%;
}

#square {
    border: 3px solid var(--light-gray);
    border-radius: 8px;
    width: 28rem;
    display: flex; /**button is flex row */
    flex-direction: column;
    align-items: center;
}

#login-button {
    margin-top: 4rem;
}

#login-h3 {
    margin: 4rem 1.5rem 0 1.5rem;
}

#login-p1 {
    margin: 1.5rem 1.5rem 0 1.5rem;
    padding: 0 1rem;
}

#login-p2 {
    margin: 1.5rem 5.5rem 5.5rem 5.5rem;
}

@media screen and (max-width: 500px) {
    #square {
        margin: 1.5rem;
        width: auto;
    }
    #login-button {
        margin-top: 1.5rem;
    }
    #login-h3 {
        margin-top: 2rem;
    }
    #login-p2 {
        margin: 1.5rem 1.5rem 2rem 1.5rem;
    }
}

</style>
